import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type CardViewLine =
  | string
  | { text: string; dir?: 'auto' | 'ltr' | 'rtl' }
  | null
  | undefined;

interface NormalizedLine {
  text: string;
  dir?: 'auto' | 'ltr' | 'rtl';
}

@Component({
  selector: 'app-card-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.css']
})
export class CardViewComponent {
  @Input() topLabel?: string | null;
  @Input() title?: string | null;
  @Input() descriptions: CardViewLine[] = [];
  @Input() linkText?: string | null;
  @Input() showEdit = false;
  @Input() showRemove = false;
  @Input() editLabel = 'Edit';
  @Input() removeAriaLabel = 'Remove item';

  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() linkClick = new EventEmitter<void>();

  get normalizedDescriptions(): NormalizedLine[] {
    return (this.descriptions ?? [])
      .map((line) => {
        if (!line) {
          return { text: '' };
        }
        return typeof line === 'string'
          ? { text: line }
          : { text: line.text ?? '', dir: line.dir };
      })
      .filter((line) => Boolean(line.text?.trim()));
  }

  get showActions(): boolean {
    return this.showEdit || this.showRemove;
  }

  handleLinkClick(event: MouseEvent): void {
    event.preventDefault();
    if (this.linkText) {
      this.linkClick.emit();
    }
  }
}
